import {
    SET_APPLICATION_ID,
} from '../../constants/ActionTypes';
import applicationIdInitialState from './applicationIdInitialState';

function applicationIdReducer(state = applicationIdInitialState, action) {
    switch (action.type) {
    case SET_APPLICATION_ID: {
        return action.id;
    }
    default:
        return state;
    }
}

export default applicationIdReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/applicationIdReducer.js